(function () {
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

  const HOST_SELECTORS = [
    'tracking-page',
    'tracking-page#root',
    '#MainContent #__next',
    '#MainContent .Astra-ThemeContainer',
    '#MainContent [class*="attaRenderer"]',
    '#MainContent [class*="attaBlock"]',
  ].join(', ');

  function isDarkRgb(value) {
    const match = value.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
    if (!match) return false;
    const r = Number(match[1]);
    const g = Number(match[2]);
    const b = Number(match[3]);
    return r + g + b < 120;
  }

  function resetAfterShipHosts() {
    document.querySelectorAll(HOST_SELECTORS).forEach(function (node) {
      if (!(node instanceof HTMLElement)) return;
      node.style.setProperty('position', 'static', 'important');
      node.style.setProperty('inset', 'auto', 'important');
      node.style.setProperty('transform', 'none', 'important');
      node.style.setProperty('width', '100%', 'important');
      node.style.setProperty('max-width', '460px', 'important');
      node.style.setProperty('max-height', 'none', 'important');
      node.style.setProperty('height', 'auto', 'important');
      node.style.setProperty('margin', '0 auto', 'important');
      node.style.setProperty('padding', '0', 'important');
      node.style.setProperty('overflow', 'visible', 'important');
      node.style.setProperty('background', 'transparent', 'important');
      node.style.setProperty('box-shadow', 'none', 'important');
      node.style.setProperty('pointer-events', 'auto', 'important');
    });
  }

  function hideDuplicatePageTitle() {
    document.querySelectorAll('#MainContent > .shopify-section h1, #MainContent > .shopify-section .h1').forEach(function (node) {
      if (!(node instanceof HTMLElement)) return;
      if (node.closest('#as-btp-page, tracking-page, iframe')) return;
      node.setAttribute('data-beybling-tracking-hidden', 'true');
    });
  }

  function fixPanelLayout(panel) {
    panel.classList.add('beybling-order-tracking-panel');
    panel.style.setProperty('position', 'relative', 'important');
    panel.style.setProperty('transform', 'none', 'important');
    panel.style.setProperty('inset', 'auto', 'important');
    panel.style.setProperty('max-height', 'none', 'important');
    panel.style.setProperty('overflow', 'visible', 'important');
    panel.style.setProperty('background', 'transparent', 'important');
    panel.style.setProperty('box-shadow', 'none', 'important');
    panel.style.setProperty('border', '0', 'important');
    panel.style.setProperty('padding', '0', 'important');
    panel.style.removeProperty('top');
    panel.style.removeProperty('left');
    panel.style.removeProperty('right');
    panel.style.removeProperty('bottom');

    panel.querySelectorAll('form, [class*="Lookup"], [class*="Container"], [class*="Styled"]').forEach(function (node) {
      if (!(node instanceof HTMLElement)) return;
      node.style.setProperty('background', 'transparent', 'important');
      node.style.setProperty('box-shadow', 'none', 'important');
    });
  }

  function fixButtonContrast(panel) {
    panel.querySelectorAll('button').forEach(function (button) {
      if (!(button instanceof HTMLElement)) return;
      if (button.getAttribute('role') === 'tab') return;

      const label = (button.textContent || '').trim().toLowerCase();
      const style = getComputedStyle(button);

      if (label.includes('phone')) {
        button.style.setProperty('background', 'transparent', 'important');
        return;
      }

      if (isDarkRgb(style.backgroundColor)) {
        button.style.setProperty('color', '#ffffff', 'important');
      }

      if (label === 'track') {
        button.style.setProperty('min-height', '46px', 'important');
        button.style.setProperty('border-radius', '9px', 'important');
        button.style.setProperty('font-weight', '600', 'important');
      }
    });
  }

  let trackingReadyDispatched = false;

  function revealTrackingPage() {
    document.documentElement.classList.remove('beybling-tracking-loading');
  }

  function signalTrackingReady() {
    if (trackingReadyDispatched) return;
    trackingReadyDispatched = true;
    stopObserver();
    revealTrackingPage();
    window.dispatchEvent(new CustomEvent('beybling:tracking-ready'));
  }

  function hasTrackingForm() {
    const panel = document.getElementById('as-btp-page');
    if (panel instanceof HTMLElement && panel.querySelector('form, input, button, [role="tab"]')) {
      return true;
    }

    return !!document.querySelector(
      '#MainContent tracking-page form, #MainContent #as-btp-page form, #MainContent [class*="attaRenderer"] form'
    );
  }

  function normalizeTrackingPage() {
    if (!document.body.classList.contains('beybling-order-tracking')) return;

    hideDuplicatePageTitle();
    resetAfterShipHosts();

    const panel = document.getElementById('as-btp-page');
    if (panel instanceof HTMLElement) {
      fixPanelLayout(panel);
      fixButtonContrast(panel);
    }

    if (hasTrackingForm()) {
      signalTrackingReady();
    }
  }

  /** @param {HTMLElement} root */
  function initOrderTrackingDvd(root) {
    const logo = root.querySelector('.beybling-order-tracking-dvd__logo');
    if (!(logo instanceof HTMLElement)) return;

    /** @type {(() => void) | null} */
    let cleanup = null;

    const measureBounds = () => {
      const isDesktop = window.matchMedia('(min-width: 750px)').matches;
      root.style.top = isDesktop ? '0' : 'var(--beybling-mobile-shell-height)';
      root.style.left = isDesktop ? 'var(--beybling-side-nav-width)' : '0';
      root.style.right = '0';
      root.style.bottom = isDesktop
        ? '0'
        : 'calc(var(--beybling-bottom-nav-height) + env(safe-area-inset-bottom, 0px))';
    };

    if (REDUCED) {
      measureBounds();
      root.dataset.beyblingOrderTrackingDvdReady = 'true';
      return;
    }

    let width = 1;
    let height = 1;
    let logoWidth = 96;
    let logoHeight = 96;
    let x = 0;
    let y = 0;
    let vx = 2.4;
    let vy = 1.85;
    let hue = 0;
    let rafId = 0;

    const syncSize = () => {
      measureBounds();
      const rect = root.getBoundingClientRect();
      width = Math.max(rect.width, 1);
      height = Math.max(rect.height, 1);
      const measured = logo.getBoundingClientRect();
      logoWidth = Math.max(measured.width, 48);
      logoHeight = Math.max(measured.height, 48);
      x = clamp(x, 0, Math.max(0, width - logoWidth));
      y = clamp(y, 0, Math.max(0, height - logoHeight));
    };

    const setHue = (nextHue) => {
      hue = nextHue % 360;
      logo.style.filter = `hue-rotate(${hue}deg) drop-shadow(0 10px 26px rgba(0, 0, 0, 0.5))`;
    };

    const tick = () => {
      x += vx;
      y += vy;

      let hitX = false;
      let hitY = false;

      if (x <= 0) {
        x = 0;
        vx = Math.abs(vx);
        hitX = true;
      } else if (x + logoWidth >= width) {
        x = Math.max(0, width - logoWidth);
        vx = -Math.abs(vx);
        hitX = true;
      }

      if (y <= 0) {
        y = 0;
        vy = Math.abs(vy);
        hitY = true;
      } else if (y + logoHeight >= height) {
        y = Math.max(0, height - logoHeight);
        vy = -Math.abs(vy);
        hitY = true;
      }

      if (hitX && hitY) setHue(hue + 48 + Math.random() * 96);
      else if (hitX || hitY) setHue(hue + 18 + Math.random() * 24);

      logo.style.transform = `translate(${x.toFixed(2)}px, ${y.toFixed(2)}px)`;
      rafId = window.requestAnimationFrame(tick);
    };

    syncSize();
    x = Math.random() * Math.max(1, width - logoWidth);
    y = Math.random() * Math.max(1, height - logoHeight);
    if (Math.random() < 0.5) vx *= -1;
    if (Math.random() < 0.5) vy *= -1;
    setHue(Math.random() * 360);
    logo.style.transform = `translate(${x.toFixed(2)}px, ${y.toFixed(2)}px)`;

    const onResize = () => syncSize();
    window.addEventListener('resize', onResize, { passive: true });
    rafId = window.requestAnimationFrame(tick);

    root.dataset.beyblingOrderTrackingDvdReady = 'true';

    cleanup = () => {
      window.cancelAnimationFrame(rafId);
      window.removeEventListener('resize', onResize);
    };

    return cleanup;
  }

  /** @type {Map<HTMLElement, () => void>} */
  const dvdCleanups = new Map();

  function destroyDvd(root) {
    const cleanup = dvdCleanups.get(root);
    if (cleanup) {
      cleanup();
      dvdCleanups.delete(root);
    }
    delete root.dataset.beyblingOrderTrackingDvdReady;
  }

  function bootDvd() {
    document.querySelectorAll('[data-beybling-order-tracking-dvd]').forEach(function (root) {
      if (!(root instanceof HTMLElement) || root.dataset.beyblingOrderTrackingDvdReady === 'true') return;
      const cleanup = initOrderTrackingDvd(root);
      if (cleanup) dvdCleanups.set(root, cleanup);
    });
  }

  /** @type {MutationObserver | null} */
  let observer = null;
  let scheduled = false;

  function schedule() {
    if (scheduled || trackingReadyDispatched) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      normalizeTrackingPage();
    });
  }

  function startObserver() {
    if (trackingReadyDispatched) return;
    const main = document.getElementById('MainContent');
    if (!main || observer) return;
    observer = new MutationObserver(schedule);
    observer.observe(main, { childList: true, subtree: true });
    schedule();
  }

  function stopObserver() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    scheduled = false;
  }

  function boot() {
    normalizeTrackingPage();
    if (!trackingReadyDispatched) {
      bootDvd();
    }
  }

  window.addEventListener('beybling:tracking-ready', function () {
    window.requestAnimationFrame(bootDvd);
  }, { once: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
      startObserver();
    });
  } else {
    boot();
    startObserver();
  }

  window.addEventListener('load', function () {
    schedule();
  }, { once: true });

  window.addEventListener('pagehide', function () {
    stopObserver();
    document.querySelectorAll('[data-beybling-order-tracking-dvd]').forEach(function (root) {
      if (root instanceof HTMLElement) destroyDvd(root);
    });
  });

  window.addEventListener('pageshow', function () {
    if (!document.body.classList.contains('beybling-order-tracking')) return;
    trackingReadyDispatched = false;
    document.documentElement.classList.add('beybling-tracking-loading');
    startObserver();
    schedule();
    if (hasTrackingForm()) {
      signalTrackingReady();
    }
  });
})();